import React from 'react';
import { Link } from 'react-router-dom';
import { Calendar, Mail, Phone } from 'lucide-react';
import { useRecentLandingPages } from '../hooks/useRecentLandingPages';

const Footer: React.FC = () => {
  const { pages: recentPages, loading: eventsLoading } = useRecentLandingPages(4);

  return (
    <footer className="border-t border-white/[.06] bg-white/[.02] py-16 text-fg-dim">
      <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo and Description */}
          <div className="space-y-6">
            <div className="flex items-center gap-2.5">
              <span className="sf-logo-mark h-[34px] w-[34px] text-[19px]">S</span>
              <span className="text-xl font-extrabold tracking-tight text-fg-bright">SOLOFIX</span>
            </div>
            <p className="text-fg-muted leading-relaxed">
              Het platform waar je je perfecte eventcrew vindt.
              Samen naar evenementen is altijd leuker!
            </p>
          </div>

          {/* Platform Links */}
          <div>
            <h4 className="sf-label-mono mb-6">Platform</h4>
            <div className="space-y-3">
              <Link to="/register" className="block text-fg-dim hover:text-fg-muted transition-colors">Aanmelden</Link>
              <Link to="/login" className="block text-fg-dim hover:text-fg-muted transition-colors">Inloggen</Link>
              <Link to="/blog" className="block text-fg-dim hover:text-fg-muted transition-colors">Blog</Link>
              <a href="#features" className="block text-fg-dim hover:text-fg-muted transition-colors">Features</a>
              <a href="#faq" className="block text-fg-dim hover:text-fg-muted transition-colors">FAQ</a>
            </div>
          </div>

          {/* Recent Events */}
          <div>
            <h4 className="sf-label-mono mb-6">Ontdek Events</h4>
            <div className="space-y-3">
              {eventsLoading ? (
                <div className="text-fg-dim text-sm">Laden...</div>
              ) : recentPages.length > 0 ? (
                recentPages.map((page) => (
                  <Link
                    key={page.slug}
                    to={`/alleen-naar-${page.slug}`}
                    className="block text-fg-dim hover:text-fg-muted transition-colors group"
                  >
                    <div className="flex items-center">
                      <Calendar className="h-3 w-3 mr-2 text-neon-cyan flex-shrink-0" />
                      <span className="text-sm truncate">
                        {page.event.title}
                      </span>
                    </div>
                    {page.event.location && (
                      <div className="text-xs text-fg-dim ml-5 truncate">
                        {page.event.location}
                      </div>
                    )}
                  </Link>
                ))
              ) : (
                <div className="text-fg-dim text-sm italic">Binnenkort meer events...</div>
              )}
            </div>
          </div>

          {/* Support */}
          <div>
            <h4 className="sf-label-mono mb-6">Support</h4>
            <div className="space-y-3">
              <a href="mailto:hello@solofix.nl" className="text-fg-dim hover:text-fg-muted transition-colors flex items-center">
                <Mail className="h-4 w-4 mr-2 text-neon-cyan" />
                hello@solofix.nl
              </a>
              <a href="tel:+31635622405" className="text-fg-dim hover:text-fg-muted transition-colors flex items-center">
                <Phone className="h-4 w-4 mr-2 text-neon-pink" />
                +316 356 224 05
              </a>
              <Link to="/help" className="block text-fg-dim hover:text-fg-muted transition-colors">Help Center</Link>
              <Link to="/privacy-statement" className="block text-fg-dim hover:text-fg-muted transition-colors">Privacy Statement</Link>
              <Link to="/algemene-voorwaarden" className="block text-fg-dim hover:text-fg-muted transition-colors">Algemene Voorwaarden</Link>
            </div>
          </div>
        </div>

        {/* Bottom section */}
        <div className="border-t border-white/[.06] mt-12 pt-8 flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
          <p className="text-fg-dim text-sm text-center md:text-left">
            © {new Date().getFullYear()} Solofix. KvK: 84894814
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
